import { Component } from '@angular/core';
import { NavController, ToastController } from 'ionic-angular';
import { HttpClient } from '../../services/HttpClient';
import { Storage } from '@ionic/storage';

import { DashboardPage } from '../dashboard/dashboard';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {

  	user = {
  		username : '',
  		password : ''
  	};

    navCtrl : NavController;
  	toastCtrl : ToastController;
    httpClient : HttpClient;
    storage : Storage;

  	constructor(navCtrl: NavController, toastCtrl : ToastController,httpClient : HttpClient, storage : Storage) {
  		this.navCtrl = navCtrl;
      this.toastCtrl = toastCtrl;
      this.httpClient = httpClient;
      this.storage = storage;
  	}

  	onSubmit(){
  		if(this.user.username.trim().length > 0){
        if(this.user.password.trim().length > 0){
          this.submit(this.user);
        }else{
          this.showMessage('Debes introducir una contraseña válida',2000);
        }
  		}else{
  			this.showMessage('Debes introducir un nombre de usuario válido',2000);
  		}
  	}

    submit(user){
      this.httpClient.post('/login',user,(error,data)=>{
        if(error){
          this.showMessage('Usuario y/o contraseña incorrectos',2000);
        }else{
          this.storageToken(data.text(), ()=>{
            this.startDashboard();
          });
        }
      });
    }

    storageToken(token, callback){
      this.storage.ready().then(()=>{
        this.storage.set('x-access-token',token).then(()=>{
          callback();
        });
      });
    }

    startDashboard(){
      this.navCtrl.push(DashboardPage);
    }

  	showMessage(message, time){
  		var toast = this.toastCtrl.create({
  			message : message,
  			duration : time,
  			position : 'top'
  		});

  		toast.present();
  	}

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts